import { EcoreUmlClass } from './ecore-uml-class';
import { EcoreUmlPackage } from './ecore-uml-package';

const models = [
    EcoreUmlClass,
    EcoreUmlPackage,
];

export default models;
